import type React from "react";

interface DirectoryIndexBubbleProps {
  readonly letter: string;
}

// Hidden from assistive tech on purpose: it is a visual echo of the scrub
// position, which the rail itself already reports.
export function DirectoryIndexBubble({
  letter,
}: DirectoryIndexBubbleProps): React.JSX.Element {
  return (
    <div
      aria-hidden="true"
      data-testid="directory-index-bubble"
      className="pointer-events-none absolute top-1/2 right-12 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-border bg-popover text-pds-xl font-semibold text-popover-foreground shadow-md"
    >
      {letter}
    </div>
  );
}
